import React from 'react'

import {Box} from '@vio/atlas/helpers/Box'

import {HotelLocationDetailsCombined} from '../HotelLocationDetails/HotelLocationDetailsCombined'
import {HotelPropertyInfo} from '../HotelPropertyInfo'

import type {ContentHotel} from '@findhotel/sapi'

interface Props {
  hotel: ContentHotel
}

export const HotelOverview: React.FC<Props> = ({hotel}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="stretch"
      desktopXs={{flexDirection: 'row'}}
      gap="s900"
    >
      <Box flex="1 0 0" minWidth="0">
        <HotelPropertyInfo hotel={hotel} />
      </Box>
      <Box flex="1 0 0" minWidth="0" display="flex" flexDirection="column">
        <HotelLocationDetailsCombined hotel={hotel} />
      </Box>
    </Box>
  )
}
